import { message } from 'antd';
import { RecordInfoDrawer } from 'components/RecordInfoDrawer';
import { TableHeader } from 'components/TableHeader';
import { DELETE_ERROR, FETCH_ERROR, SUCCESS_DELETE } from 'constants/alerts';
import { useDocumentTitle } from 'hooks/useDocumentTitle';
import { useDrawers } from 'hooks/useDrawers';
import { useHeaderChanger } from 'hooks/useHeaderChanger';
import { usePagination } from 'hooks/usePagination';
import React, { useEffect, useState, useCallback } from 'react';
import { OKEDService } from 'services/OKEDService';
import { OKEDForm } from './OKEDForm';
import { OKEDTable } from './OKEDTable';

function OKED() {
  useDocumentTitle('ОКЭД');
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const { setCount } = useHeaderChanger('ОКЭД');
  const { page, perPage, totalRows, setPagination, setTotalRows } =
    usePagination();
  const {
    state: { drawerVisible, formIsActive, activeRecord },
    openDrawer,
    closeDrawer,
    openCreateForm,
    openEditForm,
    closeForm,
  } = useDrawers();

  const fetchItems = useCallback(async () => {
    if (!page || !perPage) {
      return;
    }

    setLoading(true);

    try {
      const { items = [], total } = await OKEDService.getOKED({
        page,
        perPage,
      });
      setItems(items);
      setTotalRows(total);
      setCount(total);
    } catch (err) {
      message.error(FETCH_ERROR);
    } finally {
      setLoading(false);
    }
  }, [page, perPage]);

  useEffect(() => fetchItems(), [fetchItems]);

  const handleDelete = async () => {
    try {
      const isDeleted = await OKEDService.deleteOKED(activeRecord.id);

      if (isDeleted) {
        closeDrawer();
        fetchItems();
        message.success(SUCCESS_DELETE);
      }
    } catch (err) {
      message.error(DELETE_ERROR);
    }
  };

  return (
    <>
      <TableHeader onCreate={openCreateForm} pageId="oked" />

      <OKEDTable
        items={items}
        loading={loading}
        current={page}
        pageSize={perPage}
        onRowClick={openDrawer}
        total={totalRows}
        onChange={setPagination}
      />

      <RecordInfoDrawer
        record={activeRecord}
        drawerTitle={activeRecord?.activity}
        recordFields={[
          { label: 'Наименование', key: 'activity' },
          { label: 'Код', key: 'code' },
        ]}
        isVisible={drawerVisible}
        onClose={closeDrawer}
        onEdit={openEditForm}
        onDelete={handleDelete}
        deleteConfirmText="Вы точно хотите удалить эту запись ?"
        pageId="oked"
      />

      <OKEDForm
        isActive={formIsActive}
        initialValues={activeRecord}
        onSuccess={fetchItems}
        onClose={closeForm}
      />
    </>
  );
}

export { OKED };
